<template>
	<div class="text-value-option flex-space-between--center">
		<SIcon name="drag-sign" />
		<div class="option">
			<div class="flex-1 text-field-style">
				<input
					type="text"
					ref="mainInput"
					:value="localData.text"
					@input="updateKey"
					@keyup.enter="onEnterKey"
					placeholder="Type option..."
				/>
			</div>
			<div class="option-value">
				<CombinedInputFieldDataMenu
					class="option-value-input"
					:value.sync="localData.value"
					:textAreaMode="false"
					@input="updateOptionValue"
					@keyup.enter="onEnterKey"
					placeholder="Value"
					:attachTo="attachToValue || ''"
					:valuesTypes="dataInputMenuValueTypes"
				/>
			</div>
		</div>
		<div class="remove-btn" v-show="canRemove">
			<RemoveIcon class="remove-icon" @click="$emit('removeOption', localData)" />
		</div>
	</div>
</template>

<script>
import CombinedInputFieldDataMenu from '@/components/DataInput/CombinedInputFieldDataMenu';

import RemoveIcon from '../../assets/icon-remove-option.svg';
import ItemOnlyAllowedValueTypesMixin from '../ValueTypesMixins/ItemOnlyAllowedValueTypesMixin';

export default {
	name: 'KeyValueOption',
	mixins: [ItemOnlyAllowedValueTypesMixin],
	components: {
		RemoveIcon,
		CombinedInputFieldDataMenu,
	},
	props: {
		data: { type: Object },
		attachToValue: { type: String },
		canRemove: { type: Boolean, default: true },
	},
	watch: {
		localData: {
			handler(newV) {
				this.$emit('updateOption', newV);
			},
			deep: true,
			immediate: true,
		},
	},
	methods: {
		updateKey(e) {
			this.localData.text = e.target.value;
		},
		updateOptionValue(e) {
			this.localData.value = e.target.value;
		},
		onEnterKey() {
			this.$emit('onEnterKey');
		},
		focusInput() {
			this.$refs.mainInput.focus();
		},
	},
	data() {
		return {
			localSwitch: false,
			localData: Object.assign({ text: '', value: '' }, this.data),
		};
	},
};
</script>

<style scoped lang="scss">
.text-value-option {
	color: #cccfd7;

	> div:not(:nth-child(1)) {
		margin: 0 0 0 10px;
	}

	.option {
		width: 90%;
	}

	input {
		width: 100%;

		&:focus {
			outline: 0;
		}
	}
	.text-field-style {
		height: 46px;
	}
	.option-value-input {
	}

	.remove-btn svg {
		vertical-align: middle;
	}
	.remove-icon:hover {
		opacity: 0.6;
		cursor: pointer;
	}
}
</style>
